import { Wallet } from 'lucide-react'

export function Logo() {
  return (
    <div className="flex items-center gap-2">
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
        <Wallet className="h-5 w-5" />
      </div>
      <span className="text-xl font-bold tracking-tight text-primary">Buylog</span>
    </div>
  )
}